import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Diensten from "@/pages/Diensten";
import Verhuur from "@/pages/Verhuur";
import Offerte from "@/pages/Offerte";
import Afspraak from "@/pages/Afspraak";
import TeKoop from "@/pages/TeKoop";
import OverOns from "@/pages/OverOns";
import Contact from "@/pages/Contact";
import Privacy, { Voorwaarden } from "@/pages/Privacy";
import Betalen from "@/pages/Betalen";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route
              path="*"
              element={
                <>
                  <Header />
                  <main className="pb-20 md:pb-0">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/diensten" element={<Diensten />} />
                      <Route path="/verhuur" element={<Verhuur />} />
                      <Route path="/te-koop" element={<TeKoop />} />
                      <Route path="/offerte" element={<Offerte />} />
                      <Route path="/afspraak" element={<Afspraak />} />
                      <Route path="/over-ons" element={<OverOns />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/voorwaarden" element={<Voorwaarden />} />
                      <Route path="/betalen/:rid" element={<Betalen />} />
                      <Route path="/payment/success" element={<PaymentSuccess />} />
                      <Route path="/payment/cancel" element={<PaymentCancel />} />
                    </Routes>
                  </main>
                  <Footer />
                  <WhatsAppFloat />
                  <CookieBanner />
                </>
              }
            />
          </Routes>
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
